<!-- formulario de busqueda -->
<div [formGroup]="formBusqueda" class="mb-2 p-1 w-full border rounded border-solid border-gray-300
dark:border-gray-500 font-semibold text-base text-gray-500 dark:text-gray-200">
    <div class="w-full justify-start">
        <span class="font-bold">Busqueda Personalizada</span>
    </div>
    <br>
    <div class="grid grid-cols-4 grid-rows-2 gap-4 mt-2">
        <div>
            <div class="mb-2">
                <span for="input" class="pl-2 block mb-1 text-sm">Tipo de acta</span>
                <div class="flex">
                    <!-- Primer radio button -->
                    <div class="flex items-center">
                        <input formControlName="tipoActa" name="tipoActa" value="1" type="radio" class="ml-2 p-1 text-xs font-semibold uppercase bg-white border-blue-600 checked:bg-gray-700 dark:bg-white bg-clip-padding border border-solid rounded m-0 dark:checked:bg-blue-600"/>
                        <span class="ml-2">Acta Administrativa</span>
                    </div>
            
                    <!-- Agregar espacio entre los radios -->
                    <div class="m-7"></div>
            
                    <!-- Segundo radio button -->
                    <div class="flex items-center">
                        <input formControlName="tipoActa" name="tipoActa" value="2" type="radio" class="ml-2 p-1 text-xs font-semibold uppercase bg-white border-blue-600 checked:bg-gray-700 dark:bg-white bg-clip-padding border border-solid rounded m-0 dark:checked:bg-blue-600"/>
                        <span class="ml-2">Acta GXE</span>
                    </div>
                </div>   
            </div>
        </div>
        <div>
            <div class="mb-2">
                <span for="input" class="pl-2 block mb-1 text-sm">Fecha:</span>
                <input formControlName="fecha" type="date" class="block ml-2 p-1 text-xs font-semibold uppercase text-gray-500 bg-white dark:text-gray-100 dark:bg-gray-700 bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"/>
            </div>
        </div>
        <div>
            <div class="mb-2">
                <span for="input" class="pl-2 block mb-1 text-sm">Turno:</span>
                <select formControlName="turno" class="appearance-none block ml-2 p-1 text-xs font-semibold uppercase text-gray-500 bg-white dark:text-gray-100 dark:bg-gray-700 bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none">
                    <option value="" disabled selected>Selecciona un turno</option>
                    <option *ngFor="let turno of turnosActivos" value="{{ turno.id }}">{{ turnosNames[turno.id] }}</option>
                </select>
            </div>
        </div>
        <div>
            <div class="mb-2" *ngIf="formBusqueda.get('tipoActa').value == 2">
                <label for="input" class="pl-2 block mb-1 text-sm">Carril:</label>
                <select formControlName="carriles" multiple size="1" id="countries_multiple" class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
                    <option value="" selected disabled>Seleccionar un carril</option>
                    <option  *ngFor="let carril of carriles" value="{{ carril.id }}">{{ carril.nombre }}</option>
                </select>
            </div>
        </div>
        <div>
            <div class="mb-2">
                <span for="input" class="pl-2 block mb-1 text-sm">Cobrador:</span>
                <select formControlName="cobrador" class="appearance-none block ml-2 p-1 text-xs font-semibold uppercase text-gray-500 bg-white dark:text-gray-100 dark:bg-gray-700 bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none">
                    <option  value="" selected>Seleccionar un cobrador</option>
                    <option *ngFor="let cobrador of cobradores" value="{{ cobrador.id }}">{{ cobrador.nombre }} {{ cobrador.apellido_paterno }}</option>
                </select>
            </div>
        </div>
    
        <div class="col-span-2">
            <div class="mb-2">
                <label for="input" class="pl-2 block mb-1 text-sm">Jefe de Turno:</label>
                <select formControlName="jefeTurno" class="w-full appearance-none block ml-2 p-1 text-xs font-semibold uppercase text-gray-500 bg-white dark:text-gray-100 dark:bg-gray-700 bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none">
                    <option value="" selected>Selecciona el jefe de turno</option>
                    <option *ngFor="let jefe of jefesTurno" value="{{ jefe.id }}">{{ jefe.nombre | uppercase }} - {{ jefe.apellido_paterno | uppercase }}</option>
                </select>
            </div>
        </div>
        <div>    
            <button type="button" [disabled]="loadingIndicator" (click)="searchData()" class=" bg-gray-600 text-white inline-flex items-end  rounded p-2 text-xs font-semibold border-2 border-gray-300 drop-shadow-lg hover:border-blue-600 uppercase dark:bg-blue-600">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z" />
                </svg>  
                <span class="ml-2">Consultar</span>
            </button>
        </div>
    </div>
</div>

<!-- Resultado de consulta ngx data table -->
<div class="mb-2 p-1 w-full border rounded border-solid border-gray-300 dark:border-gray-500
 font-semibold text-base text-gray-500 dark:text-gray-200">
   <div *ngIf="rows != null; else cargandoData">
    <ngx-datatable
        class="material"
        [rows]="rows.data"
        [columns]="colums"
        [columnMode]="ColumnMode.forceFit"
        [headerHeight]="50"
        [footerHeight]="50"
        [loadingIndicator]="loadingIndicator"
        rowHeight="auto"
        [scrollbarV]="true"
        [virtualization]="false"
        [externalPaging]="true"
        [count]="rows.meta.total"
        [offset]="rows.meta.current_page"
        [limit]="rows.meta.per_page"
        (page)="setPage($event)">
        <!-- colums -->
        <ngx-datatable-column name="FECHA CREACIÓN" prop="fecha_hora">
            <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                {{ value | date: 'dd/MM/YYYY' }}
            </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="FECHA SUCESO" prop="fecha_suceso">
            <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                {{ value | date: 'dd/MM/YYYY'}}
            </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="TURNO" prop="turno">
            <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                {{  turnosNames[value.id] }}
            </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column *ngIf="formBusqueda.get('tipoActa').value == 2" name="CARRIL" prop="carril">
            <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                {{ value.nombre }}
            </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="COBRADOR" prop="cobrador">
            <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                {{ value.nombre | uppercase }} {{ value.apellido_paterno | uppercase}}
            </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="JEFE TURNO" prop="jefeTurno">
            <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                {{ value.nombre | uppercase}} {{ value.apellido_paterno | uppercase}}
            </ng-template>
        </ngx-datatable-column> 
        <ngx-datatable-column name="DESCARGA" prop="name_archivo">
            <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                <div class="mt-5 flex lg:ml-4 lg:mt-0">
                    <button (click)="downloadActa(value)" type="button"
                      class="inline-flex items-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M12 2v14m0 0l-3-3m3 3l3-3m-3 3h6" />
                      </svg>
                      Descargar
                    </button>
                </div>
            </ng-template>
        </ngx-datatable-column> 
    </ngx-datatable>
   </div>
    <ng-template class="text-center" #cargandoData>
        {{ loadingIndicator ? 'cargando información por favor espera ...' : 'selecciona la información y da click al botón consultar' }}
    </ng-template>
</div>
